import React from 'react'
import {injectIntl} from 'react-intl'
import Checkbox from '@mui/material/Checkbox'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import IconsList from 'components/IconsList'
import {getIcons} from 'utils/utils'
 
class ViewConfig extends React.Component {
    constructor(props) {
        super(props)

        const icons = getIcons()

        this.state = {
            openView: false,
            icon: props.view ? props.view.icon : icons[0],
            name: props.view ? props.view.name : '',
            isDefault: props.view && props.view.isDefault ? true : false
        }
    }

    createView = () => {
        this.props.createView({
            name: this.state.name,
            icon: this.state.icon,
            isDefault: this.state.isDefault
        }, this.props.listId)
        this.props.onClose()
    }

    updateView = () => {
        this.props.updateView({
            id: this.props.view.id,
            name: this.state.name,
            icon: this.state.icon,
            isDefault: this.state.isDefault
        }, this.props.listId)
        this.props.onClose()
    }

    deleteView = () => {
        this.props.deleteView(this.props.listId, this.props.view.id)
        this.props.onClose()
    }

	cloneView = () => {
        this.props.cloneView(this.props.view.id, this.props.listId)
        this.props.onClose()
    }

    render() {
        const {intl, view} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {view ?
                        intl.formatMessage({id: "table.view_edit_title"}) :
                        intl.formatMessage({id: "table.view_create_title"})
                    }
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        label={intl.formatMessage({id: "table.view_name"})}
                        sx={{
							width: '100%',
       						marginBottom: '20px'
						}}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH
                        }}
                    />
                    <IconsList
                        onClick={(icon) => this.setState({ icon })}
                        icon={this.state.icon}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.isDefault}
                                onChange={(e) => this.setState({ isDefault: e.target.checked })}
                            />
                        }
                        label={intl.formatMessage({id: "table.view_default"})}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {view &&
						<React.Fragment>
							<Button variant="contained" color="secondary" onClick={this.deleteView}>
								{intl.formatMessage({id: "app.confirm_delete"})}
							</Button>
							<Button variant="contained" color="primary" onClick={this.cloneView}>
								{intl.formatMessage({id: "app.duplicate"})}
							</Button>
						</React.Fragment>
                    }
                    <Button variant="contained"
                        disabled={!this.state.name || !this.state.icon}
                        onClick={view ? this.updateView : this.createView}
                        color="primary"
                    >
                        {view ? intl.formatMessage({id: "app.confirm_update"}) :
                            intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(ViewConfig)
